import { makeAutoObservable } from "mobx";
export class AuditLogStore {
    auditLog = [];
    selectedAuditEntry = null;
    constructor() {
        makeAutoObservable(this, {
            setAuditLog: true,
            setSelectedAuditEntry: true
        });
    }
    setAuditLog(auditLog) {
        this.auditLog = auditLog;
    }
    setSelectedAuditEntry(entry) {
        this.selectedAuditEntry = entry;
    }
}
